import {html, LitElement} from 'lit';
import {customElement} from 'lit/decorators.js';
import {dividerStyles} from "@/components/divider/divider.styles.ts";


@customElement('sbk-divider')
export class SbkDivider extends LitElement {
    static get styles() {
        return dividerStyles;
    }
    render() {
        return html`
            <hr>
        `;
    }
}
